<template>
  <common-dialog
    ref="dialog"
    row-key="EvaluationId"
    title="评价详情"
    width="920px"
    :data="data"
    :get-data-func="api.info"
  >
    <template slot="form">
      <el-row>
        <el-col :span="24">
          <span class>基础信息</span>
        </el-col>
      </el-row>
      <el-row class="row-border">
        <el-col :span="24">
          <el-form-item label="评价类型">
            <span>{{ data.EvaluationType }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="评级对象">
            <span>{{ data.MemberName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="评价日期">
            <span>{{ data.EvaluationDate }}</span>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="评价人员">
            <span>{{data.Anonymous ? '匿名': data.StudentName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="评价等级">
            <el-rate v-model="data.EvaluationLevel" class="evaRate" disabled></el-rate>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="评价内容" >
            <span>{{ data.Content }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <template slot="footer">
      <el-button @click="close">关闭</el-button>
    </template>
  </common-dialog>
</template>

<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/consult/evaluate").default,
      data: {
        Anonymous: true,
        Content: "",
        DpId: 0,
        DpIdChain: "",
        DpName: "",
        EvaluationDate: "",
        EvaluationId: 0,
        EvaluationLevel: 0,
        EvaluationType: "",
        MemberId: 0,
        MemberName: "",
        MemberType: 0,
        StudentId: 0,
        StudentName: null,
      },
    };
  },
};
</script>

<style lang="scss">
.evaRate {
  line-height: 32px;
  .el-rate__item {
    vertical-align: baseline !important;
    i {
      font-size: 20px;
    }
  }
}
</style>